import React, { useEffect, useState, useMemo } from "react";
import "./AdminProjects.css";
import bfLogo from "../assets/bf_logo.png";
import { useNavigate, useParams } from "react-router-dom";
import DocumentViewModal from "../components/DocumentViewModal";
import { useTranslation } from "react-i18next";

/* ===== FIREBASE ===== */
import { db, auth } from "../firebase";
import {
  collection,
  getDocs,
  query,
  where,
  doc,
  getDoc
} from "firebase/firestore";
import { onAuthStateChanged } from "firebase/auth";

/* ===== HELPERS ===== */
const getDateRangeFromKW = (kw, year) => {
  const simple = new Date(year, 0, 1 + (kw - 1) * 7);
  const dow = simple.getDay();
  const monday = new Date(simple);
  if (dow <= 4) monday.setDate(simple.getDate() - simple.getDay() + 1);
  else monday.setDate(simple.getDate() + 8 - simple.getDay());
  const sunday = new Date(monday);
  sunday.setDate(monday.getDate() + 6);

  const fmt = d =>
    `${String(d.getDate()).padStart(2, "0")}.${String(d.getMonth() + 1).padStart(2, "0")}.${d.getFullYear()}`;

  return `${fmt(monday)} – ${fmt(sunday)}`;
};

const STATUS_LABELS = {
  serga: "Serga",
  atostogos: "Atostogos",
  laisva: "Laisva",
  svente: "Šventė",
};

export default function AdminDocumentsStatus() {
  const navigate = useNavigate();
  const { status } = useParams();
  const { t } = useTranslation();

  const [rows, setRows] = useState([]);
  const [selected, setSelected] = useState(null);
  const [currentUser, setCurrentUser] = useState(null);
  const [userData, setUserData] = useState(null);

  /* 1. STEBIME PRISIJUNGIMĄ IR GAUNAME VARTOTOJO DUOMENIS */
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        setCurrentUser(user);
        const userSnap = await getDoc(doc(db, "users", user.uid));
        if (userSnap.exists()) {
          setUserData(userSnap.data());
        }
      } else {
        navigate("/admin/login");
      }
    });
    return () => unsubscribe();
  }, [navigate]);

  // MASTER ID NUSTATYMAS
  const masterId = userData?.belongsTo || currentUser?.uid;

  /* 2. UŽKRAUNAME DUOMENIS NAUDOJANT MASTER ID */
  useEffect(() => {
    if (!status || !masterId) return;

    const load = async () => {
      try {
        // Workers map (Krauname tik savo komandos darbuotojus)
        const qWorkers = query(
          collection(db, "workers"),
          where("adminId", "==", masterId)
        );
        const ws = await getDocs(qWorkers);
        const workersMap = {};
        ws.forEach(d => {
          workersMap[d.id] = d.data().name;
        });

        // Documents by status AND masterId (Tik savo komandos dokumentai)
        const qDocs = query(
          collection(db, "documents"),
          where("adminId", "==", masterId),
          where("type", "==", status)
        );
        const snap = await getDocs(qDocs);

        const map = {};
        snap.docs.forEach(d => {
          const data = d.data();
          const key = `${data.workerId}_${data.kw}`;

          if (!map[key]) {
            map[key] = {
              id: key,
              workerId: data.workerId,
              name: workersMap[data.workerId] || "—",
              kw: data.kw,
              year: data.year,
            };
          }
        });

        setRows(Object.values(map));
      } catch (err) {
        console.error("Error loading status documents:", err);
      }
    };

    load();
  }, [status, masterId]);

  const title = STATUS_LABELS[status] || "Dokumentai";

  return (
    <div className="projects-container">
      <button className="back-btn" onClick={() => navigate(-1)}>
        ← {t('back') || "Atgal"}
      </button>

      <div className="projects-content">
        <img src={bfLogo} alt="BF" className="projects-logo" />
        <h1 className="projects-title">{title}</h1>

        <div className="projects-list">
          {rows.map(item => (
            <div key={item.id} className="project-card">
              <div>
                <div className="project-name">{item.name}</div>
                <div className="project-meta">
                  KW {item.kw} · {getDateRangeFromKW(item.kw, item.year)}
                </div>
              </div>

              <div className="project-actions">
                <button
                  className="open-btn"
                  onClick={() => setSelected(item)}
                >
                  {t('view') || "Peržiūrėti"}
                </button>
              </div>
            </div>
          ))}

          {rows.length === 0 && (
            <div className="project-card" style={{ opacity: 0.6, justifyContent: 'center' }}>
              {t('no_data') || "Dokumentų nėra"}
            </div>
          )}
        </div>
      </div>

      {selected && (
        <DocumentViewModal
          item={selected}
          status={status}
          onClose={() => setSelected(null)}
        />
      )}
    </div>
  );
}